import { Grid, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTextInput from 'components/Forms/CustomTextInput';
import LabelRequired from 'components/FormFields/LabelRequired';
import { COUPON_TYPE_OPTIONS } from 'pages/PosSettings/Coupons/couponForm';

const FIELD_SX = { width: '100%' };

// A number input hides what was typed when it isn't a number — the field reads
// as empty, which here would mean "unlimited". Text keeps the input visible so
// it can be rejected with a reason.
const WHOLE_NUMBER = { inputMode: 'numeric' };
const AMOUNT = { inputMode: 'decimal' };

/**
 * The code and its usage limits, shared by the coupons page and the promotion
 * form. Must be rendered inside a Grid container and a FormProvider.
 */
const CouponFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={6}>
        <CustomTextInput
          sx={FIELD_SX}
          name="couponCode"
          label={
            <LabelRequired>{t('website_settings.coupone_code')}</LabelRequired>
          }
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextInput
          sx={FIELD_SX}
          select={true}
          name="couponType"
          label={t('Type')}
        >
          {COUPON_TYPE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(option.label)}
            </MenuItem>
          ))}
        </CustomTextInput>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('Leave a limit empty for unlimited.')}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <CustomTextInput
          sx={FIELD_SX}
          inputProps={WHOLE_NUMBER}
          name="maxUses"
          label={t('website_settings.max_use')}
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextInput
          sx={FIELD_SX}
          inputProps={WHOLE_NUMBER}
          name="maxUsesPerCustomer"
          label={t('website_settings.max_use_customer')}
        />
      </Grid>
      <Grid item xs={4}>
        <CustomTextInput
          sx={FIELD_SX}
          inputProps={AMOUNT}
          name="maxTotalDiscount"
          label={t('Discount budget')}
        />
      </Grid>
    </>
  );
};

export default CouponFields;
